export const LEAVE_TAB_MODULES = [
    'leave-applications', 'leave-apply', 'leave-my-requests', 'leave-approval',
];

const LEGACY_MODULE_ALIASES = {
    'leave-management': LEAVE_TAB_MODULES,
};

export const expandLegacyModules = (modules) => {
    if (!Array.isArray(modules) || !modules.some((k) => k in LEGACY_MODULE_ALIASES)) return modules;
    const out = new Set();
    modules.forEach((k) => {
        if (k in LEGACY_MODULE_ALIASES) LEGACY_MODULE_ALIASES[k].forEach((n) => out.add(n));
        else out.add(k);
    });
    return [...out];
};

export const ROUTE_MODULES = {
    '/dashboard': 'dashboard',
    '/dashboard/inbox': 'inbox',
    '/dashboard/employees': 'employees',
    '/dashboard/recruitment': ['recruitment-interviews', 'recruitment-vacancies', 'recruitment-candidates'],
    '/dashboard/documents': ['document-requests', 'document-approvals', 'organisation-documents', 'employee-documents'],

    '/dashboard/run-payroll': ['run-payroll', 'payroll-register'],
    '/dashboard/payslips': 'payslips',
    '/dashboard/pay-adjustments': ['advances', 'overtime'],

    '/dashboard/attendance-leave': ['attendance-overview', 'attendance', 'attendance-reports'],
    '/dashboard/client-locations': ['client-locations', 'location-tracking'],
    '/dashboard/leave-management': LEAVE_TAB_MODULES,
    '/dashboard/resignations': 'resignations',

    '/dashboard/entities': 'entities',
    '/dashboard/organisation': ['departments', 'designations'],
    '/dashboard/payroll-setup': ['salary-structures', 'statutory-deductions'],
    '/dashboard/leave-policy': ['policy-setup', 'leave-types', 'working-calendar', 'assign-shifts'],
    '/dashboard/roles': 'roles-access',
};

export const canAccessRoute = (modules, route) => {
    if (!Array.isArray(modules) || modules.length === 0) return true;

    if (!(route in ROUTE_MODULES)) return true;

    const required = ROUTE_MODULES[route];
    if (required === null) return true;
    if (Array.isArray(required)) return required.some((k) => modules.includes(k));
    return modules.includes(required);
};

export const hasModule = (modules, key) =>
    !Array.isArray(modules) || modules.length === 0 || modules.includes(key);

export const routeAccessKey = (pathname) => {
    if (pathname in ROUTE_MODULES) return pathname;
    let best = null;
    Object.keys(ROUTE_MODULES).forEach((key) => {
        if (key === '/dashboard') return;
        if (pathname.startsWith(`${key}/`) && (!best || key.length > best.length)) best = key;
    });
    return best;
};

export const canAccessPath = (modules, pathname) => {
    if (!Array.isArray(modules) || modules.length === 0) return true;
    const key = routeAccessKey(pathname);
    if (!key) return true;
    return canAccessRoute(modules, key);
};

export const firstAccessibleRoute = (modules) => {
    const match = Object.keys(ROUTE_MODULES).find((route) => canAccessRoute(modules, route));
    return match || null;
};
